import { svgSprite } from './zui-logos-svg.js';

const $_logosContainer = document.createElement('div');
$_logosContainer.style.display = 'none';

$_logosContainer.innerHTML = svgSprite;

document.head.appendChild($_logosContainer);
